var map = {
	"./1.png": 1577,
	"./2.png": 1578,
	"./3.png": 1579,
	"./4.png": 1580,
	"./5.png": 1581,
	"./6.png": 1582,
	"./7.png": 1583,
	"./8.png": 1584
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1576;